import { useState, useEffect, useMemo } from "react";
import Seo from "../components/Seo";
import NewsCard from "../components/NewsCard";
import FeaturedNewsCard from "../components/FeaturedNewsCard";
import { fetchNews } from "../cms/news";

const KATEGORIEN = ["Alle", "B-Junioren TSS", "C-Junioren TSS", "Allgemein"];

export default function News() {
  const [news, setNews]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState("Alle");

  useEffect(() => {
    fetchNews()
      .then(setNews)
      .finally(() => setLoading(false));
  }, []);

  // Neuester gepinnter Artikel (nur relevant, solange kein Kategorie-Filter aktiv ist)
  const featured = useMemo(
    () => news.find((a) => a.gepinnt) || null,
    [news]
  );

  const gefiltert = useMemo(() => {
    return filter === "Alle"
      ? news.filter((a) => !featured || a.id !== featured.id)
      : news.filter((a) => a.kategorie === filter);
  }, [news, filter, featured]);

  return (
    <>
      <Seo
        title="News"
        description="Aktuelle Berichte und Neuigkeiten vom Team Sempachersee."
        path="/news"
      />

      {/* Page-Header */}
      <section className="bg-primary text-white">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <p className="text-accent font-bold uppercase tracking-widest text-xs mb-3">Aktuell</p>
          <h1 className="text-5xl md:text-6xl font-extrabold uppercase">News</h1>
        </div>
      </section>

      {/* Kategorie-Filter */}
      <section className="border-b border-black/10 bg-white sticky top-0 z-10">
        <div className="mx-auto max-w-6xl px-4">
          <div className="flex gap-2 overflow-x-auto py-4 no-scrollbar">
            {KATEGORIEN.map((k) => (
              <button
                key={k}
                onClick={() => setFilter(k)}
                className={`flex-shrink-0 px-4 py-2 text-sm font-bold uppercase tracking-wide transition-colors ${
                  filter === k
                    ? "bg-primary text-white"
                    : "bg-black/5 text-dark/60 hover:bg-black/10"
                }`}
              >
                {k}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* News-Grid */}
      <section className="mx-auto max-w-6xl px-4 py-16">
        {loading ? (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3].map((n) => (
              <div key={n} className="bg-dark/5 animate-pulse h-72" />
            ))}
          </div>
        ) : news.length === 0 ? (
          <p className="text-dark/60">Noch keine News erfasst.</p>
        ) : (
          <>
            {/* Featured-Artikel nur bei "Alle" ganz oben zeigen */}
            {filter === "Alle" && featured && (
              <div className="mb-10">
                <FeaturedNewsCard artikel={featured} />
              </div>
            )}

            {gefiltert.length === 0 ? (
              <p className="text-dark/60">Keine News in dieser Kategorie.</p>
            ) : (
              <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                {gefiltert.map((artikel) => (
                  <NewsCard key={artikel.id} artikel={artikel} />
                ))}
              </div>
            )}
          </>
        )}
      </section>
    </>
  );
}
